import React from 'react';
import { useWorkViewStore } from '../../shared/store/WorkViewStore';
import { usesWorkDuration } from '../../shared/enum/EnumRepository';
import { convertWorkSizeToString, getMainSizeData } from '../../shared/dto/EntityRepository';
import WorkDetailList from './WorkDetailList';
import { convertS3UrlToCloudFrontUrl } from '../../shared/aws/awsHelper';
import { useWorkPropertyVisible } from '../../shared/hooks/useApi/useWorkPropertyVisible';
import RelatedProjectList from '../work/RelatedProjectListInWork';
import WorkViewerImg from './WorkViewerImg';
import WorkViewerVideo from './WorkViewerVideo';
import LoadingInComp from '../../shared/component/LoadingInComp';
import { useWorkContentModeStore } from '../../shared/store/workContentModeStore';
import { getWorkTextFieldValue } from '../../shared/util/workDisplayText';

const WorkViewer: React.FC = () => {
  const activeWork = useWorkViewStore((s) => s.activeWork);
  const handleChange = useWorkViewStore((s) => s.updateActiveWork);
  const isOverviewOpen = useWorkViewStore((s) => s.isOverviewOpen);
  const { workPropertyVisible } = useWorkPropertyVisible();
  const workContentMode = useWorkContentModeStore((s) => s.workContentMode);

  if (!isOverviewOpen || !workPropertyVisible) return null;
  if (!activeWork) return <LoadingInComp isLoading={true} />;

  const engVisible = workPropertyVisible.engVisible !== false;
  const resolvedTitle = getWorkTextFieldValue(
    activeWork, 'title', workContentMode, engVisible, false,
  );
  const resolvedMaterial = getWorkTextFieldValue(
    activeWork, 'material', workContentMode, engVisible, false,
  );
  const sizeTextValue = activeWork.sizeText ?? '';
  const mainSize = getMainSizeData(activeWork.sizes, activeWork.mainSizeUnit);
  const convertedStringSize = convertWorkSizeToString(
    mainSize,
    activeWork.dimensionsType,
    sizeTextValue,
  );
  const convertedCloudFrontUrl = convertS3UrlToCloudFrontUrl(activeWork.uploadFile.originUrl);

  return (
    <>
      {usesWorkDuration(activeWork.workType) && (
        <WorkViewerVideo
          title={resolvedTitle}
          convertedCloudFrontUrl={convertedCloudFrontUrl}
          handleVideoUrlChange={(value) => handleChange({ videoUrl: value })}
        />
      )}
      {!usesWorkDuration(activeWork.workType) && (
        <WorkViewerImg
          title={resolvedTitle}
          material={resolvedMaterial}
          contertedStringSize={convertedStringSize}
          prodYear={activeWork.prodYear}
          allowDownload={activeWork.uploadFile.allowDownload}
          convertedCloudFrontUrl={convertedCloudFrontUrl}
        />
      )}
      <WorkDetailList />
      <RelatedProjectList />
    </>
  );
}

export default WorkViewer;
